var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetterQ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7595,
    cy: 11.8821,
    r: 11.3821,
    fill: "#EBF6FD",
    stroke: "#71B9F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8138 15.844L17.8278 16.091C17.5548 17.235 16.9308 17.807 15.9558 17.807C14.9028 17.807 14.3178 17.248 13.6548 16.156C13.4338 16.169 13.2648 16.182 13.1608 16.182C11.8478 16.182 10.7688 15.74 9.92376 14.856C9.07876 13.972 8.64976 12.854 8.64976 11.489C8.64976 10.124 9.07876 9.006 9.92376 8.109C10.7688 7.225 11.8478 6.783 13.1608 6.783C14.4608 6.783 15.5398 7.225 16.3978 8.109C17.2428 9.006 17.6718 10.124 17.6718 11.489C17.6718 12.555 17.3988 13.478 16.8658 14.271C16.3198 15.064 15.5918 15.623 14.6818 15.935C15.0848 16.546 15.4098 16.819 15.9428 16.819C16.4238 16.819 16.6708 16.52 16.8138 15.844ZM10.7688 8.811C10.1318 9.526 9.81976 10.41 9.81976 11.489C9.81976 12.568 10.1318 13.452 10.7688 14.154C11.3928 14.856 12.1858 15.207 13.1608 15.207C14.1358 15.207 14.9418 14.856 15.5658 14.154C16.1898 13.452 16.5018 12.568 16.5018 11.489C16.5018 10.41 16.1898 9.526 15.5658 8.811C14.9418 8.109 14.1358 7.758 13.1608 7.758C12.1858 7.758 11.3928 8.109 10.7688 8.811Z",
    fill: "#52AAF5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterQ);
export default __webpack_public_path__ + "static/media/letterQ.2d93a461f3c6f20bdbc004bc6c0cc7d6.svg";
export { ForwardRef as ReactComponent };